/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

export interface AdnFormStateRegistration {
  markDirty(): void;
  isDirty(): boolean;
  resetSubmission(): void;
}

@Injectable({
  providedIn: 'root'
})
export class AdnFormStateService {
  private currentForm: AdnFormStateRegistration | null = null;

  setCurrentForm(form: AdnFormStateRegistration): void {
    this.currentForm = form;
  }

  markDirty(): void {
    if (!this.currentForm) {
      return;
    }

    this.currentForm.resetSubmission();
    this.currentForm.markDirty();
  }

  isDirty(): boolean {
    return this.currentForm?.isDirty() ?? false;
  }

  deregister(): void {
    this.currentForm = null;
  }
}
